var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", eager: "", "max-width": "600" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card-title",
        { staticClass: "cyan darken-1 white--text" },
        [
          _c("v-icon", { staticClass: "white--text", attrs: { left: "" } }, [
            _vm._v("edit"),
          ]),
          _vm._v("\n    Personalizza ruoli\n    "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "white--text",
              attrs: { depressed: "", light: "", icon: "" },
              on: { click: _vm.dismiss },
            },
            [_c("v-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-sheet",
        {
          staticClass: "white",
          staticStyle: { height: "550px", "overflow-y": "auto" },
        },
        [
          _c("div", { staticClass: "pa-4" }, [
            _vm._v("\n      I ruoli iniziali sono quelli del listone\n      "),
            _c("span", { staticClass: "label-fp" }, [_vm._v("Fantapazz")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "svincolati-options pa-4" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-center align-center" },
              _vm._l(_vm.Constants.RUOLO, function (ruolo_id) {
                var _obj
                return _c(
                  "v-btn",
                  {
                    key: ruolo_id,
                    attrs: { depressed: "", icon: "", large: "" },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.selectRuolo(ruolo_id)
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "Ruolo outline",
                        class:
                          ((_obj = {}),
                          (_obj["Ruolo_" + ruolo_id] = true),
                          (_obj.selezionato = _vm.selectedRuolo == ruolo_id),
                          _obj),
                      },
                      [_vm._v(_vm._s(_vm.ruolo(ruolo_id)))]
                    ),
                  ]
                )
              }),
              1
            ),
          ]),
          _vm._v(" "),
          _vm.filtered_calciatori.length == 0
            ? _c("div", { staticClass: "text-center pa-10" }, [
                _vm._v("\n      Nessun calciatore\n    "),
              ])
            : _c(
                "div",
                { staticClass: "ruoli-custom-list" },
                [
                  _c("RecycleScroller", {
                    ref: "vscroll-list",
                    staticClass: "recycle-scroller",
                    class: { "nice-scroll": !_vm.is_mobile },
                    attrs: { items: _vm.filtered_calciatori, "item-size": 65 },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var filtered_calciatore = ref.item
                          return [
                            _c(
                              "div",
                              { staticClass: "ruoli-custom-list-item" },
                              [
                                _c("calciatore", {
                                  attrs: {
                                    borderAsRuolo: "",
                                    textScuro: "",
                                    bgChiaro: "",
                                    id: filtered_calciatore.id,
                                  },
                                }),
                                _vm._v(" "),
                                _c("v-select", {
                                  staticClass: "selectRuolo",
                                  attrs: {
                                    dense: "",
                                    items: _vm.getRuoliSelectOptions(
                                      filtered_calciatore.id
                                    ),
                                    outlined: "",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChange(
                                        filtered_calciatore.id
                                      )
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "item",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(item.text),
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                      {
                                        key: "selection",
                                        fn: function (ref) {
                                          var item = ref.item
                                          return [
                                            _c("div", {
                                              domProps: {
                                                innerHTML: _vm._s(item.text),
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.newRuoli[filtered_calciatore.id],
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newRuoli,
                                        filtered_calciatore.id,
                                        $$v
                                      )
                                    },
                                    expression:
                                      "newRuoli[filtered_calciatore.id]",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }